import { serverApi } from '../index';
import { NotificationContact } from 'types/notification';
import { Notification } from 'types/notification';
import { KeySetPaginationReq, KeySetPaginationRes } from 'types/key-set-pagination';

const extendedApi = serverApi.injectEndpoints({
  endpoints: (builder) => ({
    updateNotificationStatus: builder.mutation<void, { id: string; statusId: number; note?: string }>({
      query: ({ id, statusId, note }) => {
        return { url: `/notifications/${id}/status/${statusId}`, method: 'PUT', body: { note } };
      },
      invalidatesTags: (_, __, { id: _id }) => [{ type: 'Notification', _id }]
    }),
    getNotification: builder.query<Notification, string>({
      query: (id) => `/notifications/${id}`,
      providesTags: (_, __, id) => [{ type: 'Notification', id }]
    }),
    getNotifications: builder.query<KeySetPaginationRes<Notification>, KeySetPaginationReq>({
      query: (arg) => {
        return { url: `/notifications`, params: arg || undefined };
      },
      providesTags: (result) =>
        result ? [...result.docs.map(({ _id }) => ({ type: 'Notification' as const, _id })), 'Notification'] : ['Notification']
    }),
    getNotificationsCount: builder.query<{ total_count: number }, { id: number; filter: KeySetPaginationReq['filter'] }>({
      query: ({ id, ...arg }) => {
        return { url: `/notifications/count`, params: arg || undefined };
      },
      providesTags: ['Notification']
    }),
    removeNotificationContact: builder.mutation<void, number>({
      query: (id) => ({ url: `/notifications/contacts/${id}`, method: 'delete' }),
      invalidatesTags: ['NotificationContact']
    }),
    getNotificationContact: builder.query<NotificationContact, number>({
      query: (id) => `/notifications/contacts/${id}`,
      providesTags: (_, __, id) => [{ type: 'NotificationContact', id }]
    }),
    updateNotificationContact: builder.mutation<void, Omit<NotificationContact, 'user_id' | 'notification_method_id'>>({
      query: ({ id, ...body }) => ({ url: `/notifications/contacts/${id}`, method: 'put', body }),
      invalidatesTags: ['NotificationContact']
    }),
    getNotificationMonthlyCost: builder.query<number, { id: number; gallons: number }>({
      query: ({ id, gallons }) => `/notifications/${id}/monthly-cost/${gallons}`,
      providesTags: ['Notification']
    })
  }),
  overrideExisting: false
});

export const {
  useUpdateNotificationStatusMutation,
  useGetNotificationQuery,
  useLazyGetNotificationQuery,
  useRemoveNotificationContactMutation,
  useLazyGetNotificationContactQuery,
  useUpdateNotificationContactMutation,
  useGetNotificationsQuery,
  useGetNotificationsCountQuery
} = extendedApi;
